module.exports = __webpack_public_path__ + "static/media/vote-undefined.357098d3.svg";